import { TABLE_EVENT_TYPE } from "../../core/TABLE_EVENT_TYPE";

export function bindButtonClickEvent(table) {
    table.on(TABLE_EVENT_TYPE.CLICK_CELL, (e => {
        const {col: col, row: row, target: target} = e;
        "button" !== target.name || target.attribute.disable || table.hasListeners(TABLE_EVENT_TYPE.BUTTON_CLICK) && table.fireListeners(TABLE_EVENT_TYPE.BUTTON_CLICK, {
            col: col,
            row: row,
            event: e.event
        });
    }));
}
//# sourceMappingURL=button.js.map
